"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTextColor = exports.BadgeText = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = _interopRequireDefault(require("../../theme"));
var _typographyHelper = require("../../utils/typographyHelper");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var getCSS = function getCSS(fontSize, lineHeight) {
  return "font-size: ".concat((0, _typographyHelper.pxToRem)(fontSize), "; line-height: ").concat((0, _typographyHelper.getLineHeight)({
    fontSize: fontSize,
    expectedLineHeight: lineHeight
  }), ";");
};
var getTextSize = function getTextSize(size) {
  switch (size) {
    case 'large':
      return getCSS(15, 18);
    case 'medium':
      return getCSS(14, 16);
    default:
      return getCSS(12, 16);
  }
};
var getTextColor = exports.getTextColor = function getTextColor(color) {
  switch (color) {
    case 'light':
      return 'white';
    case 'dark':
    default:
      return _theme["default"].grey120;
  }
};
var BadgeText = exports.BadgeText = _styledComponents["default"].span.withConfig({
  displayName: "styled-components__BadgeText",
  componentId: "sc-126oi2o-0"
})(["font-family:", ";color:", ";font-weight:600;display:block;text-transform:", ";", ";"], _theme["default"].buenosAires, function (_ref) {
  var color = _ref.color;
  return getTextColor(color);
}, function (_ref2) {
  var uppercase = _ref2.uppercase;
  return uppercase ? 'uppercase' : 'none';
}, function (_ref3) {
  var size = _ref3.size;
  return getTextSize(size);
});